import React, {useState, createContext} from 'react'

export const DataLayerEventContext = createContext()

export const DataLayerEventProvider = (props) => {
    const[dataLayerEventState, setDataLayerEventState] = useState({
        eventCalled: {}
    })
    return (
        <DataLayerEventContext.Provider value={[dataLayerEventState,setDataLayerEventState]}>
            {props.children}
        </DataLayerEventContext.Provider>
    )
}